(function() {
  'use strict';
  
  function initMP4Players() {
    document.querySelectorAll('[data-mp4-player]:not([data-initialized])').forEach(function(container) {
      container.dataset.initialized = 'true';
      
      var video = container.querySelector('video');
      var playBtn = container.querySelector('[data-play-btn]');
      var pauseIndicator = container.querySelector('[data-pause-indicator]');
      var durationBadge = container.closest('.page-hero-video__player-wrap').querySelector('[data-duration-badge]');
      var startTime = parseFloat(container.dataset.startTime) || 0;
      
      var pauseTimeout = null;
      
      // Set initial start time when metadata loads
      video.addEventListener('loadedmetadata', function() {
        if (startTime > 0 && video.currentTime < startTime) {
          video.currentTime = startTime;
        }
      });
      
      // Fallback: also try setting on canplay for cross-browser support
      video.addEventListener('canplay', function() {
        if (startTime > 0 && video.currentTime < 1) {
          video.currentTime = startTime;
        }
      }, { once: true });
      
      function flashPause() {
        if (!pauseIndicator) return;
        clearTimeout(pauseTimeout);
        pauseIndicator.classList.add('page-hero-video__mp4-pause--visible');
        pauseTimeout = setTimeout(function() {
          pauseIndicator.classList.remove('page-hero-video__mp4-pause--visible');
        }, 600);
      }
      
      function togglePlay() {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
          flashPause();
        }
      }
      
      // Click to play/pause
      container.addEventListener('click', function(e) {
        e.preventDefault();
        togglePlay();
      });
      
      // Update UI on play
      video.addEventListener('play', function() {
        container.classList.add('page-hero-video__mp4-container--playing');
      });
      
      // Update UI on pause
      video.addEventListener('pause', function() {
        container.classList.remove('page-hero-video__mp4-container--playing');
      });
      
      // Loop video when ended - restart from start_time
      video.addEventListener('ended', function() {
        video.currentTime = startTime;
        video.play();
      });
    });
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMP4Players);
  } else {
    initMP4Players();
  }
  
  // Watch for dynamic content
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function(mutations) {
      if (mutations.some(function(m) { return m.addedNodes.length > 0; })) {
        initMP4Players();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();